import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import ProcessAutoQuizContainer from "./ProcessAutoQuizContainer";
import ProcessAutoResults from "./ProcessAutoResults";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";

export interface ProcessAutoResult {
  questionId: number;
  selectedOption: number;
  scores: {
    workflowAutomation: number;
    taskEfficiency: number;
    integration: number;
  };
}

const ProcessAutoQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        index
        element={
          <UserInfoForm
            onSubmit={handleUserInfoSubmit}
            subtitle="Streamline Your Operations with Automation"
          />
        }
      />
      <Route
        path="quiz"
        element={<ProcessAutoQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<ProcessAutoResults />} />
      <Route path="*" element={<Navigate to="/processauto" replace />} />
    </Routes>
  );
};

export default ProcessAutoQuiz;
